import z from "zod";

export const paymentTermSchema = z.object({
	id: z.number().nullable(),
	days: z.number().min(1).max(60),
	externalReference: z.string().min(1).max(60),
	isDefault: z.boolean(),
});

export type PaymentTermSchemaInput = z.input<typeof paymentTermSchema>;
export type PaymentTermSchemaOutput = z.output<typeof paymentTermSchema>;

export const paymentTermSelectOptionSchema = z.object({
	id: z.number(),
	days: z.number(),
	externalReference: z.string().nullish(),
	isDefault: z.boolean().nullish(),
});
